
import  Common from './common';
import  CreateNote from './createNote';
import  LeftPanel from './leftPanelContainer';
import  MiddlePanel from './middlePanelContainer';
import  RightPanel from './rightPanelContainer';
import  CombineView from './combineView';


const array = [].concat(Common, CreateNote, LeftPanel, MiddlePanel, RightPanel, CombineView);

export default  array;